import { render, staticRenderFns } from "./InventarioArmasComponent.vue?vue&type=template&id=7543de9b"
import script from "./InventarioArmasComponent.vue?vue&type=script&lang=js"
export * from "./InventarioArmasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports